import {
  getApiPurewaveSettingRadio,
  patchApiPurewaveSettingRadio,
} from '@/shared/api'
import { type EventOrCallableType } from '@/shared/lib/utils'
import { createMutation, createQuery } from '@farfetched/core'

export const radioQuery = createQuery({
  handler: getApiPurewaveSettingRadio,
})

export type RadioQueryFinishedSuccess = EventOrCallableType<
  typeof radioQuery.finished.success
>

export type RadioQueryFinishedSuccessResult =
  RadioQueryFinishedSuccess['result']

export const radioUpdate = createMutation({
  handler: patchApiPurewaveSettingRadio,
})

export type RadioUpdateStart = EventOrCallableType<typeof radioUpdate.start>

export type RadioUpdateFinishedSuccess = EventOrCallableType<
  typeof radioUpdate.finished.success
>

export type RadioUpdateFinishedSuccessResult =
  RadioUpdateFinishedSuccess['result']
